import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { TranslateModule } from '@ngx-translate/core';
import { AirportModule } from '../airport/airport.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { CoreModule } from '@app/core/core.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthModule } from '@app/core/auth/auth.module';
import { RouterModule } from '@angular/router';
import { SeasonModule } from '../season/season.module';
import { SharedModule } from '@app/shared/shared.module';



@NgModule({
  declarations: [TopBarComponent],
  imports: [
    SharedModule,
    CommonModule,
    CoreModule,
    TranslateModule,
    AirportModule,
    SeasonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    CoreModule,
    NgbModule,
    AuthModule,
    RouterModule
  ],
  exports: [TopBarComponent]
})
export class TopBarModule { }
